import React, { useRef, useEffect, useState } from "react";
import { Route, useLocation, Switch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Top from "~/components/pages/Top";
import Footer from "~/components/Blocks/Footer";
import AppNaviBar from "~/components/Blocks/AppNaviBar";
import ApplicationForm from "~/components/pages/ApplicationForm";
import MemberManagement from "~/components/pages/MemberManagement";
import PartyList from "~/components/pages/PartyList";
import PartyDetail from "~/components/pages/PartyDetail";
import Login from "~/components/pages/Login";
import PasswordSetting from "~/components/pages/PasswordSetting";
import PasswordSettingEdit from "~/components/pages/PasswordSettingEdit";
import EntranceUser from "~/components/pages/EntranceUser";
import CreateUser from "~/components/pages/CreateUser";
import UserInfo from "~/components/pages/UserInfo";
import MemberForm from "~/components/pages/MemberForm";
import NotFound from "~/components/pages/NotFound";
import CallbackLogin from "~/components/pages/CallbackLogin";
import { UserInfoGet, AdminInfoGet } from "../stores/Information";
import { errorHandler_set } from "../stores/slices/ErrorHandler";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { green, orange, blue } from "@mui/material/colors";
import Box from "@mui/material/Box";
const theme = createTheme({
    palette: {
        primary: {
            main: blue[400],
        },
        // secondary: {
        //     main: green[500],
        // },
    },
});

const App = (state) => {
    const dispatch = useDispatch();
    useEffect(() => {
        //ログイン情報取得
        dispatch(UserInfoGet(null));
    }, []);
    const informationState = useSelector((state) => state.Information);
    if (informationState["organizer"]["user_login"] === true) {
        console.log(informationState["organizer"]["organizer_id"] + "ログイン中");
    } else {
        console.log("ログアウト中");
    }
    //↑↑

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // 共通エラー表示
    const errorState = useSelector((state) => state.ErrorHandler);
    const history = useHistory();
    useEffect(() => {
        if (errorState.return_flag) {
            alert("エラーが発生しました。");
            history.push("/");
            dispatch(errorHandler_set(["return_flag", false]));
        } else if (errorState.no_return_flag) {
            alert("エラーが発生しました。");
            dispatch(errorHandler_set(["no_return_flag", false]));
        }
    }, [errorState]);

    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <AppNaviBar />
                <Box sx={{ minHeight: "500px" }}>
                    <Switch>
                        {/* 共通 */}
                        <Route
                            path="/"
                            component={() => (
                                <>
                                    <Top />
                                </>
                            )}
                            exact
                        />
                        <Route path="/ApplicationForm" component={ApplicationForm} exact />
                        <Route path="/Login" component={Login} exact />
                        <Route path="/PasswordSetting" component={PasswordSetting} exact />
                        <Route path="/PasswordSettingEdit" component={PasswordSettingEdit} exact />
                        <Route path="/PasswordSettingEdit/:id" component={PasswordSettingEdit} exact />
                        <Route path="/PartyList" component={PartyList} exact />
                        <Route path="/PartyDetail" component={PartyDetail} exact />
                        <Route path="/EntranceUser" component={EntranceUser} exact />
                        <Route path="/CreateUser/:id" component={CreateUser} exact />
                        <Route path="/UserInfo" component={UserInfo} exact />
                        <Route path="/MemberManagement" component={MemberManagement} exact />

                        {/* 参加者画面 */}
                        <Route path="/Member/Form/:form_token" component={MemberForm} exact />

                        <Route path="/CallbackLogin/:id" component={CallbackLogin} exact />

                        <Route>
                            <NotFound />
                        </Route>
                    </Switch>
                </Box>
                <Footer />
            </ThemeProvider>
        </React.Fragment>
    );
};

export default App;
